<template>
  <AppSection id="invoices" :title="$getConst.pages.invoice.invoices" type="page">
    <b-form-group id="scope" :label="$t($getConst.pages.scope.scopes)" label-for="scope-input" v-if="adminRole">
      <multiselect
        v-model="scope"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="$store.getters['auth/allScopes']"
        :show-labels="false"
        :searchable="true"
        @input="changeScope"
      >
      </multiselect>
    </b-form-group>
    <AppSection
      id="permissions-table"
      :title="$t($getConst.pages.invoice.list_of_invoices)"
      type="section"
      :button="hasPermission($getConst.permissions.addInvoice)"
      :button-text="$getConst.pages.button.add"
      :button-icon="$getConst.icons.add"
      second-button
      @onClick="addInvoice"
    >

      <template #secondButton>
        <b-dropdown class="ml-auto" toggle-class="text-success font-weight-bold" variant="link">
          <template #button-content>
            <AppSvgIcon class="mr-2" :icon="$getConst.svgIcons.excel"/>{{$t($getConst.pages.excel.excel) | capitalize}}
          </template>
          <b-dropdown-item-button button-class="py-2 font-weight-bold" @click="exportExcel">
            {{$t($getConst.pages.excel.export) | capitalize}}<i :class="[$getConst.icons.export, 'ml-2']"/>
          </b-dropdown-item-button>
          <b-dropdown-item-button button-class="py-2 font-weight-bold" @click="openPreImportModal">
            {{$t($getConst.pages.excel.import) | capitalize}}<i :class="[$getConst.icons.import, 'ml-2']"/>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <AppDataTable
        :key="tableKey"
        ref="invoicesTable"
        :fields="fields"
        :end-point="endPoint"
        :actions="actions"
        @onEdit="editInvoice"
        @onDelete="confirmDelete"
        @onShow="showInvoice"

      >
      </AppDataTable>
      <PreImportRapportModal
        :scope-id="scope ? scope.id : null"
        @importedInvoices="tableKey++"
      />
    </AppSection>
    <AppConfirmationModal
        id="confirmation-modal"
        :title=$t($getConst.pages.profile.are_you_sure) | capitalize
        ref="confirmDelete"
        @onCancel="invoiceToDelete = null"
        @onConfirm="deleteInvoice"/>
  </AppSection>
</template>

<script>
  import AppDataTable from "../../../components/common/table/AppDataTable";
  import AppSection from "../../../components/common/sections/AppSection";
  import PreImportRapportModal from "./PreImportRapportModal";
  import {deleteInvoice} from "../../../api/invoices.api";
  import AppConfirmationModal from "../../../components/common/modals/AppConfirmationModal";
  import {exportInvoices, exportInvoicesByScope} from "../../../api/invoices.api";


  export default {
    name: "index",
    components: {PreImportRapportModal, AppConfirmationModal, AppSection, AppDataTable},
    data() {
      return {
        fields: [
          {key: 'worker_full_name', label:'Worker full name', sortable: true, filterable: true},
          {key: 'issued_date', label: 'Date of issue' ,sortable: true, filterable: 'date'},
          {key: 'due_date', label: 'Due date',sortable: true, filterable: 'date'},
          {key: 'timesheet_hours', label: 'Total hours' ,sortable: true, filterable: true},
          {key: 'amount_client', label: 'Amount due', sortable: true, filterable: true},
        ],
        scope: null,
        endPoint: null,
        adminRole: null,
        tableKey: 0,
        actions: [
          {
            action: 'onEdit',
            variant: 'outline-secondary',
            icon: this.$getConst.icons.edit,
            permissions: [this.$getConst.permissions.updateInvoice]
          },
          {
            action: 'onDelete',
            variant: 'outline-danger',
            icon: this.$getConst.icons.delete,
            permissions: [this.$getConst.permissions.deleteInvoice]
          },
          {
            action: 'onShow',
            variant: 'outline',
            icon: this.$getConst.icons.eye,
            permissions: [this.$getConst.permissions.readInvoice]
          },
        ],
        invoiceToDelete: null,
        is_loading: false
      }
    },
    methods: {
      addInvoice() {
        this.$router.push({name: this.$getConst.routesNames.addInvoice});
      },
      editInvoice(invoice) {
        this.$router.push({name: this.$getConst.routesNames.editInvoice, params: {id: invoice.id}});
      },
      showInvoice(invoice) {
        this.$router.push({name: this.$getConst.routesNames.invoiceDetails, params: {invoiceId: invoice.id}});
      },
      confirmDelete(invoice) {
        this.invoiceToDelete = invoice;
        this.$bvModal.show('confirmation-modal');
      },
      deleteInvoice(){
        this.is_loading = true;
        deleteInvoice(this.invoiceToDelete.id).then(
          response => {
            this.$refs.invoicesTable.removeItem(this.invoiceToDelete);
            this.$refs.confirmDelete.close();
            this.$snotify.success(this.$t(this.$getConst.pages.invoice.invoice_deleted));
          },
          error => {
            this.handleApiError(error);
          }
        );
      },
      changeScope() {
        if (this.scope) {
          this.endPoint = '/invoicesInScope/' + this.scope.id;
        } else {
          this.endPoint = '/invoices';
        }
      },
      exportExcel() {
        if(this.scope) {
          exportInvoicesByScope(this.scope.id,{
            responseType: 'blob',
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              const today = new Date();
              const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
              const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
              const dateTime = date + ' ' + time;
              link.setAttribute('download', 'invoices-' + this.scope.name + '-' + dateTime + '.xlsx')
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            },
            (error) => {
              this.handleApiError(error);
            })
        } else {
          exportInvoices({
            responseType: 'blob',
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              const today = new Date();
              const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
              const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
              const dateTime = date + ' ' + time;
              link.setAttribute('download', 'invoices-' + 'all-' + dateTime + '.xlsx')
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            },
            (error) => {
              this.handleApiError(error);
            })
        }
      },
      openPreImportModal() {
        this.$bvModal.show("pre-import-rapport")
      }
    },
    created() {
      this.endPoint = '/invoices';
      this.adminRole=this.isAdmin(this.$store.getters["auth/role"]);
    },
  }
</script>

<style lang="scss" scoped>
  .badge {
    height: inherit;
    width: 80%;
  }
  .dropdown::v-deep .dropdown-item:active {
    background: #28a745 !important;
    color: #fff !important;
  }
</style>
